import { render } from "./StatusChip.vue?vue&type=template&id=15970c80&ts=true"
import script from "./StatusChip.vue?vue&type=script&lang=ts"
export * from "./StatusChip.vue?vue&type=script&lang=ts"

import "./StatusChip.vue?vue&type=style&index=0&id=15970c80&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__